// ============================================================================
// ORGANISATION MASTER ENDPOINTS
// ============================================================================
// Tenant-scoped: /tenants/{tenantId}/organisation/{entities|business-units|financial-years}

import { buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';
import type { OrganisationKind } from '../types/organisation.types';

const base = '/tenants/:tenantId/organisation/:kind';

export const organisationEndpoints = {
  /** GET (paged) and POST */
  list: (tenantId: ID, kind: OrganisationKind) =>
    buildEndpointWithParams(base, { tenantId, kind }),

  /** GET, PUT, DELETE one row by canonical id */
  byId: (tenantId: ID, kind: OrganisationKind, id: ID) =>
    buildEndpointWithParams(`${base}/:id`, { tenantId, kind, id }),

  /** POST — financial years only */
  setCurrent: (tenantId: ID, id: ID) =>
    buildEndpointWithParams(`${base}/:id/set-current`, { tenantId, kind: 'financial-years', id }),

  /** POST — financial years only */
  close: (tenantId: ID, id: ID) =>
    buildEndpointWithParams(`${base}/:id/close`, { tenantId, kind: 'financial-years', id }),
} as const;

export default organisationEndpoints;
